/* CINE — la capa de scroll con GSAP. Cuadros Splash (15 sep 2026).

   Qué es y qué NO es.
   ------------------
   Los dos directores que ya había —cs-vivo.js en la portada y cs-sala.js en
   el resto— hacen ENTRADAS: una pieza está oculta, entra en pantalla y
   aparece. Van con IntersectionObserver y CSS, tienen tres redes de
   seguridad y funcionan aunque falle todo. **No se tocan.**

   Esta capa hace otra cosa distinta: movimiento ATADO AL SCROLL (`scrub`).
   La sala se aleja mientras bajas, las obras derivan a distinta velocidad
   según su columna, el lienzo del hero se va girando. Es lo que da sensación
   de profundidad, y es justo lo que no se puede hacer con CSS.

   Que sean cosas distintas es lo que permite sumarlas sin pelea: una decide
   la opacidad al entrar, la otra desplaza mientras se baja.

   > REGLA DE ORO, la misma de siempre: un cuadro NUNCA puede quedarse
   > invisible. Aquí no se oculta nada. Todo lo que toca este guion es
   > desplazamiento y giro; si no llega a ejecutarse, la página se ve
   > entera y quieta. Por eso no hay estados iniciales en el CSS.

   EL DETALLE QUE HAY QUE RESPETAR: `x`/`y` están COGIDOS.
   ------------------------------------------------------
   hero-profundidad.js mueve las capas del hero con el ratón usando
   `gsap.quickTo(el, 'x')` y `'y'`. Este guion mueve LAS MISMAS capas con el
   scroll — y por eso usa `yPercent` y `xPercent`, nunca `x` ni `y`.

   GSAP guarda cada componente del transform por separado y los compone al
   pintar, así que ratón y scroll conviven sin pisarse. Si alguien cambia
   aquí `yPercent` por `y`, el hero se vuelve loco: la última que escriba
   gana y las dos escriben sesenta veces por segundo. Está avisado.

   Ajuste del listón: Gabriel pidió "con más presencia" (15 sep 2026). Los
   recorridos de PRESENCIA de abajo son ese listón. Para bajarlo, tocar ese
   objeto y nada más.
*/
(function () {
  'use strict';

  /* Caja negra, como la de cs-vivo.js: cada hito deja constancia de qué pasó
     y cuándo. Se mira con `window.csCine` en la consola. Sin esto, cuando
     una coreografía no arranca solo queda adivinar. */
  var caja = { pasos: [] };
  window.csCine = caja;
  function apunte(que, dato) {
    caja.pasos.push({ t: Math.round(performance.now()), que: que, dato: dato });
  }
  apunte('guion-leido');

  /* ---------- ¿toca animar? ---------- */

  var parametro = null;
  try {
    parametro = new URLSearchParams(window.location.search).get('vivo');
  } catch (e) {
    /* navegador viejo: sin forzado */
  }
  /* Se respeta el mismo interruptor que cs-vivo.js y cs-sala.js: ?vivo=si
     fuerza el movimiento, ?vivo=no lo apaga. Un solo mando para toda la
     tienda.

     EL INTERRUPTOR SE RECUERDA DURANTE LA VISITA (15 sep 2026).
     Gabriel tiene «reducir movimiento» puesto en su Windows, asi que sin
     ?vivo=si no ve ni una de las animaciones que encarga. Y el parametro se
     perdia en cuanto pinchaba un enlace — justo lo que se hace al revisar la
     tienda: portada, coleccion, ficha. Ahora la eleccion dura lo que dure la
     pestana, y basta con ponerlo una vez.

     sessionStorage y no localStorage a proposito: esto es una herramienta
     para revisar, no un ajuste del visitante. Al cerrar la pestana vuelve a
     mandar lo que diga el sistema, que es lo correcto. */
  try {
    if (parametro === 'si' || parametro === 'no') {
      sessionStorage.setItem('cs-vivo', parametro);
    } else if (!parametro) {
      parametro = sessionStorage.getItem('cs-vivo');
    }
  } catch (e) {
    /* modo privado o almacenamiento bloqueado: manda la URL y ya esta */
  }

  if (parametro === 'no') return apunte('apagado-por-url');
  var forzado = parametro === 'si';

  /* El «reducir movimiento» y el ancho mínimo NO se comprueban aquí: los
     lleva gsap.matchMedia() al final del fichero, que además desmonta la
     coreografía si la condición deja de cumplirse. El porqué, allí.

     El ancho mínimo existe porque el scrub obliga a pintar en cada cuadro,
     y en un móvil modesto eso se nota más que luce. Abajo quedan las
     entradas de cs-vivo, que son baratas. */

  /* ---------- el listón ---------- */

  var PRESENCIA = {
    heroFoto: 18, /* % que sube la sala mientras el hero se va */
    heroLuz: 30,
    heroLienzo: -14, /* negativo: el lienzo se queda, la sala huye */
    heroPanel: 26,
    obraDeriva: 26, /* px que deriva la obra dentro de su marco */
    temaDeriva: 12, /* la mitad: la foto de categoria va en `contain` */
    cabecera: 40, /* px que sube el titular de sección */
    banda: 9 /* % que deriva la foto de la cabecera de colección */
  };

  /* ---------- utilidades ---------- */

  var urlGsap = document.currentScript && document.currentScript.dataset.gsap;
  var urlScrollTrigger = document.currentScript && document.currentScript.dataset.scrolltrigger;

  function carga(url) {
    return new Promise(function (res, rej) {
      if (!url) return rej(new Error('sin url'));
      var s = document.createElement('script');
      s.src = url;
      s.onload = function () { res(); };
      s.onerror = function () { rej(new Error('no cargó ' + url)); };
      document.head.appendChild(s);
    });
  }

  /* GSAP suele estar ya (lo trae la sección del sofá). Se espera un poco y,
     si no aparece, se trae. Mismo patrón que hero-profundidad.js.

     LOS 3 SEGUNDOS DE CORTESÍA SE SALTAN SI LA PÁGINA LO HA PRECARGADO
     (20 sep 2026). Esa espera está para no bajar 114 KB que otro guion ya
     venía trayendo. Pero cuando una página pone `<link rel=preload>` de
     GSAP está diciendo exactamente lo contrario: «lo quiero YA y nadie más
     lo va a traer». Esperar entonces es esperar por nada.

     Y costaba justo eso: 3 s. Medido en la tienda con el preload puesto, el
     fichero estaba descargado a los 342 ms y `conGsap()` no lo daba por
     bueno hasta los 3835. La animación del nombre salía casi cuatro
     segundos tarde — lo que Gabriel notó como «tarda un poco en aparecer».
     No era la descarga: era la cola.

     Las demás páginas no cambian: sin preload, la cortesía sigue igual. */
  var gsapPrecargado = !!document.querySelector(
    'link[rel="preload"][as="script"][href*="gsap.min"]'
  );

  function conGsap() {
    if (window.gsap && window.ScrollTrigger) return Promise.resolve();
    if (window.__csCine) return window.__csCine;

    if (gsapPrecargado) {
      apunte('gsap-precargado');
      window.__csCine = (window.gsap ? Promise.resolve() : carga(urlGsap))
        .then(function () { return window.ScrollTrigger ? null : carga(urlScrollTrigger); });
      return window.__csCine;
    }

    window.__csCine = new Promise(function (res, rej) {
      var intentos = 0;
      var espera = setInterval(function () {
        if (window.gsap && window.ScrollTrigger) { clearInterval(espera); return res(); }
        if (++intentos < 12) return; /* 3 s de cortesía */
        clearInterval(espera);
        var cadena = window.gsap ? Promise.resolve() : carga(urlGsap);
        cadena
          .then(function () { return window.ScrollTrigger ? null : carga(urlScrollTrigger); })
          .then(res, rej);
      }, 250);
    });
    return window.__csCine;
  }

  function cuandoQuepa(fn) {
    function luego() {
      if ('requestIdleCallback' in window) window.requestIdleCallback(fn, { timeout: 2500 });
      else setTimeout(fn, 900);
    }
    /* Se espera a `load` por lo mismo que cs-vivo: antes de que las imágenes
       den su altura, la página está comprimida y ScrollTrigger mediría mal
       dónde empieza y acaba cada sección. */
    if (document.readyState === 'complete') luego();
    else window.addEventListener('load', luego, { once: true });
  }

  /* ---------- 0. El scroll suave ---------- */

  /* POR QUÉ LENIS Y NO ScrollSmoother, teniendo los dos.
     ScrollSmoother es de GSAP y encaja solo con ScrollTrigger, que suena
     mejor. Pero exige envolver TODA la página en #smooth-wrapper /
     #smooth-content y mueve ese envoltorio con un transform — y un
     antepasado con transform rompe `position: fixed` y `position: sticky`.
     Esta tienda vive de las dos cosas: la cabecera pegada, el panel del
     asesor, el aviso del 10%, la cesta. Habría que ir sacándolos uno a uno
     del envoltorio.

     Lenis no envuelve nada: intercepta la rueda y mueve el scroll de verdad
     de la ventana, interpolado. Todo lo pegajoso sigue funcionando porque
     para el navegador esto SIGUE siendo un scroll normal.

     LO IMPORTANTE ES EL ENGANCHE. Si Lenis y ScrollTrigger corren cada uno
     por su lado, ScrollTrigger lee la posición cuando el navegador avisa y
     Lenis la está moviendo entre medias: las animaciones van un paso por
     detrás y dan tirones. Por eso Lenis avanza DENTRO del reloj de GSAP
     (`gsap.ticker`) y le avisa a ScrollTrigger en cada paso. Un solo reloj
     para los dos.

     Y `lagSmoothing(0)`: por defecto GSAP, si un fotograma tarda mucho,
     hace como que no ha pasado el tiempo. Con el scroll atado al reloj eso
     se nota como un salto. */
  function scrollSuave() {
    if (!window.csLib) return Promise.resolve();

    /* UNA SOLA INSTANCIA, PASE LO QUE PASE. Esta función la llama el callback
       de gsap.matchMedia(), y matchMedia lo vuelve a ejecutar cada vez que la
       condición se cumple otra vez — al cruzar los 750 px de ancho, por
       ejemplo. Sin esta guarda, agrandar y encoger la ventana deja DOS Lenis
       moviendo el mismo scroll, y ahí sí que se rompe del todo. */
    if (window.csLenis) return Promise.resolve();

    /* Y NO SE MONTA EN PÁGINAS CON SECCIÓN ANCLADA (el pasillo).
       Mientras algo está anclado, ScrollTrigger cambia la altura de la página
       sobre la marcha (mete un pin-spacer). Lenis, que lleva su propia cuenta
       de "a dónde voy", se queda con un destino que ya no existe: la página
       da tirones, se pasa de largo o se queda clavada. Es exactamente lo que
       Gabriel describió como «se ha roto el scroll en el inicio» (15 sep
       2026).
       Se puede hacer que convivan con ScrollTrigger.normalizeScroll, pero eso
       hay que MIRARLO funcionando antes de ponerlo en una tienda que vende, y
       de momento no se ha podido. Hasta entonces manda el scroll del
       navegador, que no falla. */
    if (document.querySelector('[data-cs-pasillo].cs-pasillo--anclado')) {
      return Promise.resolve(apunte('sin-scroll-suave', 'hay seccion anclada'));
    }

    return window.csLib
      .pide('lenis')
      .then(function () {
        if (!window.Lenis) return;
        var lenis = new window.Lenis({
          duration: 1.15, /* lento, como el resto de la casa */
          easing: function (t) { return Math.min(1, 1.001 - Math.pow(2, -10 * t)); },
          smoothWheel: true,
          /* En el móvil NO. El scroll del dedo lo hace el sistema y lo hace
             mejor: interceptarlo se nota como que el dedo va pegajoso, y
             además rompe el gesto de "tirar para recargar". */
          smoothTouch: false
        });

        lenis.on('scroll', ScrollTrigger.update);
        gsap.ticker.add(function (t) {
          lenis.raf(t * 1000); /* el reloj de GSAP va en segundos, Lenis en ms */
        });
        gsap.ticker.lagSmoothing(0);
        window.csLenis = lenis; /* para poder pararlo desde la consola */
        apunte('scroll-suave');
      })
      .catch(function (e) {
        /* Sin Lenis, el scroll del navegador de toda la vida. No se pierde
           nada: las coreografías van atadas al scroll, no a Lenis. */
        apunte('sin-scroll-suave', String((e && e.message) || e));
      });
  }

  /* ---------- 1. El hero se aleja ---------- */

  /* RETIRADO EL 19 SEP 2026. Se deja el codigo para que se entienda lo que
     hubo, pero NO SE LLAMA. Fue la fuente de casi todo lo que fallo ese dia:

     - Movia la capa del cuadro 3D, que no tiene holgura, y lo cortaba.
     - Apagaba el panel del texto a 0,25 de opacidad: contraste 2,1:1.
     - Y lo que quedaba —la sala y la luz subiendo con el scroll— PELEABA con
       hero-profundidad.js, que mueve ESAS MISMAS capas con el raton. Dos
       guiones escribiendo sobre los mismos elementos, uno atado al scroll con
       scrub y otro al puntero con un easing de 1,5 s: al bajar con el raton
       encima, la sala daba tirones. Gabriel lo describio tal cual.

     hero-profundidad.js es anterior, funcionaba, y da la profundidad con el
     raton, que es donde se nota en una sala. Con un solo guion moviendo cada
     capa no hay pelea. Si algun dia se quiere profundidad con el scroll en el
     hero, que sea EN VEZ del raton, no ENCIMA. */
  function hero() {
    var hero = document.querySelector('.custom-hero');
    if (!hero) return;
    var media = hero.querySelector('.custom-hero__media');
    if (!media) return;

    var foto = media.querySelector('.custom-hero__capa--foto');
    var luz = media.querySelector('.custom-hero__capa--luz');
    var lienzo = media.querySelector('.custom-hero__capa--lienzo');
    var panel = hero.querySelector('.custom-hero__panel') || hero.querySelector('.custom-hero__content');

    var linea = gsap.timeline({
      scrollTrigger: {
        trigger: hero,
        start: 'top top',
        end: 'bottom top',
        scrub: 1.1, /* el retardo es lo que hace que flote en vez de pegarse */
        /* Hace falta para que el valor de abajo (el del lienzo, que es una
           funcion) se vuelva a preguntar al cambiar el ancho de la ventana.
           Sin esto, quien cruza los 990 px se queda con el de antes. */
        invalidateOnRefresh: true
      }
    });

    /* Cada capa a su velocidad: esa diferencia ES la profundidad. */
    if (foto) linea.to(foto, { yPercent: PRESENCIA.heroFoto, ease: 'none' }, 0);
    if (luz) linea.to(luz, { yPercent: PRESENCIA.heroLuz, ease: 'none' }, 0);
    if (lienzo) {
      /* SOLO SE DESPLAZA. NO SE GIRA, Y NO ES UN CAPRICHO.
         Esta capa lleva dentro el <model-viewer> del lienzo 3D, o sea un
         canvas de WebGL vivo. Girar su contenedor obliga al navegador a
         recomponer ese canvas en cada fotograma, y con `will-change` puesto
         encima lo rasteriza a menor resolución: el cuadro se ve sucio y con
         los bordes dentados. Gabriel lo cazó a ojo el 15 sep 2026.
         Además el modelo YA gira solo en 3D (`auto-rotate`, 6°/s); girar
         también la caja de fuera es contar dos veces el mismo gesto y se
         nota como un fallo, no como profundidad.
         Un desplazamiento sí es gratis: mover una capa no la recompone. */
      /* Y POR DEBAJO DE 990 px NO SE MUEVE NADA. A partir de ahi el hero se
         APILA: la sala pasa a ocupar el ancho entero y crece mucho de alto
         (675 px a 900 de ancho, contra 340 cuando va al lado del panel). El
         14% de esa altura son 95 px, y esta capa no tiene holgura ninguna
         —`inset: 0`, y `.custom-hero__media` recorta— asi que subirla le
         corta la cabeza al cuadro. Se ve como si el cuadro se escapara por
         arriba, que es justo lo que Gabriel describio el 19 sep 2026.
         La capa de la foto si tiene holgura (`inset: -28px`), pero solo a
         partir de 990: por debajo tampoco la tiene, y por eso tampoco se
         estira ahi.
         Las otras dos capas siguen moviendose, asi que la profundidad no se
         pierde: lo unico que se queda quieto es el cuadro. */
      /* Y AL FINAL NO SE MUEVE A NINGUN ANCHO (19 sep 2026).
         Primero se dejo quieto solo por debajo de 990, donde el hero se apila
         y la capa crece de alto. Pero Gabriel lo volvio a ver cortado por
         arriba en pantalla ancha, y tenia razon: el problema no es el ancho,
         es que esta capa NO TIENE HOLGURA. Va con `inset: 0` y
         `.custom-hero__media` recorta, asi que cualquier desplazamiento, sea
         del tamano que sea, se come un trozo del cuadro por un borde. La capa
         de la foto puede moverse porque le sobran 28 px por cada lado
         (`inset: -28px` a partir de 990); esta no.
         Darle esa misma holgura NO vale: `radioPara()` mide precisamente esta
         capa para encuadrar el modelo, asi que agrandarla cambiaria el tamano
         del cuadro — y de eso ya hemos tenido bastante por hoy.
         Asi que se queda quieta. La profundidad la siguen dando las otras dos
         capas, que es donde se nota de verdad: la sala se va y el cuadro se
         queda, que era justo la idea. */
      void lienzo;
    }
    /* EL PANEL SUBE, PERO YA NO SE APAGA (19 sep 2026).
       Aqui habia un `opacity: 0.25` con un comentario que decia que a ese
       suelo "el texto sigue legible". No sigue: medido en la pagina, el
       titular a 0,25 de opacidad queda en CONTRASTE 2,1:1 sobre el azul del
       panel, cuando el minimo para leer es 4,5:1. Y el hero se apaga entero
       en menos de una pantalla de scroll, asi que basta con bajar un poco
       para que "Falta el tuyo", el parrafo y el boton ELEGIR CUADRO se queden
       lavados. Gabriel lo describio como "el texto se ve raro", y llevaba
       razon las tres veces que lo dijo.
       Ademas ahi esta el boton de comprar: apagar la llamada a la accion
       mientras el visitante baja es justo lo contrario de lo que interesa.
       El desplazamiento se queda, que es lo que da la profundidad; lo que se
       cae es el apagado. */
    if (panel) linea.to(panel, { yPercent: PRESENCIA.heroPanel, ease: 'none' }, 0);
  }

  /* ---------- la obra deriva DENTRO de su marco ---------- */

  /* POR QUÉ NO SE MUEVE LA TARJETA, Y POR QUÉ HAY UN ENVOLTORIO.
     Dos lecciones de la primera versión, las dos vistas en pantalla:

     1. Moviendo la TARJETA entera, la rejilla se descuadra. Cada baldosa
        deriva lo suyo y las filas quedan dentadas — en una galería eso no
        se lee como profundidad, se lee como roto. Lo que tiene que derivar
        es la obra dentro de su marco, que para eso el marco recorta.

     2. Pero tampoco se puede mover la <img>: `cs-home.css` ya le pone
        `transform: scale()` al pasar el ratón por encima, y un transform en
        línea de GSAP gana siempre a una regla de hoja. Le habríamos comido
        el zoom del hover.

     De ahí el envoltorio: un <span> que se mete entre el marco y la imagen.
     GSAP mueve el envoltorio, el CSS sigue mandando en la imagen, y no se
     pisan porque son dos elementos distintos. */
  function envuelve(img) {
    if (!img || img.parentNode.classList.contains('cs-cine__plano')) {
      return img && img.parentNode;
    }
    var plano = document.createElement('span');
    plano.className = 'cs-cine__plano';
    img.parentNode.insertBefore(plano, img);
    plano.appendChild(img);
    return plano;
  }

  function deriva(plano, px, suavidad) {
    if (!plano) return;
    gsap.fromTo(
      plano,
      { y: px },
      {
        y: -px,
        ease: 'none',
        scrollTrigger: {
          trigger: plano,
          start: 'top bottom',
          end: 'bottom top',
          scrub: suavidad
        }
      }
    );
  }

  /* ---------- 2. La rejilla de obras ---------- */

  function obras() {
    var piezas = document.querySelectorAll('.cs-obra');
    if (piezas.length < 2) return;

    Array.prototype.forEach.call(piezas, function (pieza, i) {
      var img = pieza.querySelector('.cs-obra__img');
      if (!img) return;
      /* Tres ritmos alternos. Con uno solo, toda la fila derivaría a la vez
         y el ojo no lo leería como fondo, sino como que la página resbala. */
      var ritmo = [1, 0.6, 0.82][i % 3];
      deriva(envuelve(img), PRESENCIA.obraDeriva * ritmo, 0.8);
    });
  }

  /* ---------- 3. El mosaico de temáticas ---------- */

  function mosaico() {
    var fichas = document.querySelectorAll('.cs-tema');
    if (fichas.length < 2) return;

    Array.prototype.forEach.call(fichas, function (ficha, i) {
      var img = ficha.querySelector('.cs-tema__img');
      if (!img) return;
      /* Aquí la deriva es la mitad que en las obras a propósito: la foto de
         la categoría va con `object-fit: contain`, así que a los lados ya
         hay fondo a la vista. Moverla mucho descompensa ese margen y parece
         que la obra se ha descolgado del paspartú. */
      var ritmo = [1, 0.55, 0.8][i % 3];
      deriva(envuelve(img), PRESENCIA.temaDeriva * ritmo, 0.9);
    });
  }

  /* ---------- 4. La banda de cabecera de colección ---------- */

  function bandaColeccion() {
    var banda = document.querySelector('.cs-sala-cab');
    if (!banda) return;
    var figura = banda.querySelector('.cs-sala-cab__media');
    var texto = banda.querySelector('.cs-sala-cab__inner');
    if (!figura) return;

    /* Se mueve el <figure>, NO la <img>. Es la misma lección que en las
       tarjetas: la imagen puede llevar reglas propias, el contenedor no.
       Y la banda es `overflow: hidden`, que es lo que hace de ventana. */
    var linea = gsap.timeline({
      scrollTrigger: { trigger: banda, start: 'top bottom', end: 'bottom top', scrub: 1 }
    });
    linea.fromTo(figura,
      { yPercent: -PRESENCIA.banda },
      { yPercent: PRESENCIA.banda, ease: 'none' }, 0);
    /* El rótulo va a la mitad de velocidad: si fuera a la misma, la banda
       entera se movería en bloque y no habría profundidad ninguna. */
    if (texto) {
      linea.fromTo(texto,
        { yPercent: -PRESENCIA.banda * 0.35 },
        { yPercent: PRESENCIA.banda * 0.35, ease: 'none' }, 0);
    }
  }

  /* ---------- 5. EL PASILLO: la sala se recorre andando ---------- */

  /* La sección se queda clavada en pantalla (`pin`) y, mientras el visitante
     sigue bajando, la tira de obras viaja de derecha a izquierda. El scroll
     deja de mover la página y pasa a mover la sala.

     CUÁNTO DURA EL ANCLAJE NO SE INVENTA: se mide. `end` es lo que sobra de
     la tira por la derecha (ancho total menos lo que cabe en pantalla), así
     que la sala recorre exactamente lo que mide y ni un píxel más. Si se
     pusiera un número fijo —'+=2000'— el anclaje se quedaría corto al añadir
     una obra y largo al quitarla, y el visitante se comería un tramo muerto
     con la sala ya parada.

     `invalidateOnRefresh` es la otra mitad de lo mismo: al cambiar el ancho
     de la ventana la cuenta se rehace. Sin eso, girar el móvil deja el
     recorrido descuadrado. */
  function pasillo() {
    var seccion = document.querySelector('[data-cs-pasillo]');
    if (!seccion) return;
    var ventana = seccion.querySelector('[data-cs-pasillo-ventana]');
    var tira = seccion.querySelector('[data-cs-pasillo-tira]');
    if (!ventana || !tira) return;

    function sobra() {
      return Math.max(0, tira.scrollWidth - ventana.clientWidth);
    }
    /* Si no sobra nada —pocas obras, pantalla muy ancha— no hay pasillo que
       recorrer: se queda la tira quieta y en paz. Anclar aquí solo serviría
       para secuestrar el scroll sin enseñar nada. */
    if (sobra() < 120) return apunte('pasillo-no-hace-falta', sobra());

    seccion.classList.add('cs-pasillo--anclado');

    var linea = gsap.timeline({
      scrollTrigger: {
        trigger: seccion,
        start: 'top top',
        /* CUÁNTO SE QUEDA CLAVADA LA PÁGINA — y por qué hay un tope.
           La primera versión anclaba tanto scroll como medía la tira: 2.945
           px con ocho obras, casi tres pantallas y media con la página
           aparentemente parada. Quien no sepa que eso es una galería que
           avanza de lado piensa que la web se ha colgado, y eso fue justo lo
           que pasó (15 sep 2026).
           Ahora el anclaje no pasa de UNA PANTALLA Y MEDIA, que es lo que se
           aguanta sin dudar. La tira sigue recorriéndose entera: lo que
           cambia es que va más deprisa de lado. Añadir obras ya no alarga el
           secuestro del scroll, solo acelera el paseo. */
        end: function () {
          return '+=' + Math.min(sobra(), window.innerHeight * 1.5);
        },
        pin: true,
        scrub: 1,
        anticipatePin: 1,
        invalidateOnRefresh: true
      }
    });

    linea.to(tira, {
      x: function () { return -sobra(); },
      ease: 'none'
    }, 0);

    apunte('pasillo', Math.round(sobra()));
  }

  /* ---------- 6. Los titulares se abren ---------- */

  /* SplitText parte el titular en líneas y cada línea entra por debajo de la
     de arriba, como si se destapara. Es el gesto de un libro de tipografía,
     y aquí viene a cuento: la marca vende obra impresa.

     POR LÍNEAS Y NO POR LETRAS, a propósito. Letra a letra es el efecto que
     todo el mundo hace y con una tipografía de gran cuerpo como Instrument
     Serif se lee mal mientras dura. Por líneas se sigue leyendo la frase
     entera desde el primer fotograma.

     DOS CUIDADOS QUE SplitText NO TE DA GRATIS:

     · `aria-hidden` en los trozos y el texto original devuelto al terminar
       (`revert()`), porque partir un titular deja al lector de pantalla
       leyendo sílabas sueltas. GSAP 3.13 lo hace solo si se le pasa
       `aria: 'auto'`, que es lo que se hace aquí.
     · Esperar a las fuentes. Si se parte antes de que cargue Instrument
       Serif, las líneas se calculan con la tipografía de reserva y al
       cambiar la buena quedan cortadas por donde no era. */
  function titulares() {
    /* EL PARRAFO DEL HERO SALE DE AQUI (20 sep 2026).
       Estaba `.custom-hero__subheading` en esta lista, y era la misma
       enfermedad que ya nos ha mordido dos veces hoy: DOS SISTEMAS ANIMANDO
       UNA MISMA COSA. Ese parrafo ya tiene su entrada en cs-vivo.css (opacidad
       y un alza, con su rescate para "reducir movimiento" y `both`, o sea que
       siempre acaba visible). Encima, aqui se partia en lineas, cada linea se
       metia en una mascara con `overflow: clip` y se empujaba un 115% hacia
       abajo hasta que disparara el scroll. Si ese disparo no llegaba, el
       parrafo NO EXISTIA. Medido en la pagina: opacidad 0 y las lineas
       todavia 29 px por debajo de su mascara.
       Y no es un titular: es el parrafo que explica lo que se vende. Partirlo
       en lineas no aporta nada que justifique arriesgarse a que no aparezca.
       Los titulares de verdad —`cs-head__t`, `cs-pasillo__t`— se quedan: esos
       si son un adorno, y si fallan se ven enteros igual. */
    var piezas = Array.prototype.filter.call(
      document.querySelectorAll('.cs-pasillo__t, .cs-head__t'),
      function (pieza) {
        return !pieza.closest('.cs-cat__linea');
      }
    );
    if (!piezas.length) return;
    if (!window.csLib) return;

    window.csLib
      .pide('splittext')
      .then(function () {
        if (!window.SplitText) return;
        var fuentes = document.fonts && document.fonts.ready
          ? document.fonts.ready
          : Promise.resolve();
        return fuentes.then(function () {
          Array.prototype.forEach.call(piezas, function (pieza) {
            /* EL MISMO AGUJERO QUE TENÍA LA CODA (20 sep 2026): al cruzar
               los 750 px de ida y vuelta, matchMedia rearma y esto partía
               un titular YA PARTIDO, anidando líneas dentro de líneas. Aquí
               solo se pone el portero y no se revierte al desarmar: estos
               titulares son de toda la casa y tocar su desmontaje sería
               meterse en la portada por la puerta de atrás. Con no repetir
               el corte, el problema desaparece. */
            if (pieza.dataset.csPartido) return;
            pieza.dataset.csPartido = '1';

            var corte = new window.SplitText(pieza, {
              type: 'lines',
              linesClass: 'cs-linea',
              mask: 'lines', /* la ventana que hace que la línea suba desde abajo */
              aria: 'auto'
            });
            gsap.from(corte.lines, {
              yPercent: 115,
              duration: 1.1,
              ease: 'power3.out',
              stagger: 0.09,
              scrollTrigger: {
                trigger: pieza,
                start: 'top 85%',
                once: true /* se abre una vez; no es un adorno que se repita */
              }
            });
          });
          apunte('titulares', piezas.length);
        });
      })
      .catch(function (e) {
        /* Sin SplitText el titular se queda como estaba: entero y legible.
           Que es, por cierto, el estado bueno. */
        apunte('sin-splittext', String((e && e.message) || e));
      });
  }

  /* ---------- 7. Las cabeceras de sección ---------- */

  function cabeceras() {
    var cabs = document.querySelectorAll('.cs-head');
    if (!cabs.length) return;

    Array.prototype.forEach.call(cabs, function (cab) {
      gsap.fromTo(
        cab,
        { y: PRESENCIA.cabecera },
        {
          y: -PRESENCIA.cabecera * 0.4,
          ease: 'none',
          scrollTrigger: {
            trigger: cab,
            start: 'top bottom',
            end: 'bottom top',
            scrub: 1
          }
        }
      );
    });
  }

  /* ---------- 8. La página de Ebora ---------- */

  /* LO QUE ESTE GUION YA HACÍA EN ESTA PÁGINA, Y POR ESO NO SE REPITE AQUÍ.
     `titulares()` ya parte los dos `.cs-head__t` de la página (el de la
     trayectoria y el de la franja de obras) y `cabeceras()` ya desplaza sus
     `.cs-head`. `obras()` ya mueve las cuatro obras del final. Tocar
     cualquiera de esos tres desde aquí sería el fallo de siempre: DOS
     SISTEMAS MOVIENDO UNA MISMA COSA. Esta función se ocupa SOLO de lo que
     no tenía dueño: el retrato, la línea de tiempo, la coda y los derechos.

     Y una cosa más, sobre el reparto del riesgo. Casi todo lo de aquí va con
     `scrub`, o sea atado a la POSICIÓN del scroll y no a que un disparo
     llegue. Es deliberado: una animación con `scrub` no se puede quedar a
     medias — su progreso es una función de dónde estás, así que si el texto
     ya ha pasado, está encendido. Es la vacuna contra lo que pasó con el
     párrafo del hero, que se quedaba invisible esperando un disparo que no
     llegaba. Lo único que va por tiempo es la entrada del retrato, que está
     sobre la línea de flotación y tiene su propia red más abajo. */

  var entradaEbora = null; /* la guarda el rescate */
  var retratoJugado = false; /* la entrada se reproduce UNA vez, venga de donde venga */
  var codaPartida = null; /* la instancia de SplitText, para poder deshacerla */
  var codaAnimacion = null;
  var codaIntento = 0;

  /* La entrada de arriba: solo si acabamos de llegar y nadie ha tocado nada.
     Reproducir una entrada sobre algo que el visitante lleva rato mirando no
     es una entrada: es un parpadeo. Así que se piden dos cosas y si falla
     cualquiera no se anima NADA — la página se queda entera, que es su
     estado bueno.

     DE LAS DOS, LA QUE MANDA ES EL SCROLL. Si nadie ha bajado, el visitante
     sigue mirando la banda oscura y el brochazo es una sorpresa; si ya ha
     bajado, el nombre está fuera de pantalla y repintarlo no lo vería nadie
     salvo al volver arriba, donde sí cantaría.

     El tope de tiempo es la segunda condición, y va en 6 s por una medida:
     en el servidor local GSAP tarda 3,9 s en estar listo (`gsap-listo` en la
     caja negra), así que un tope de 3 s dejaba la entrada sin reproducir
     NUNCA. 6 s es el mismo número que el RESCATE de cs-vivo.js — si a los
     6 s todavía no ha llegado, es que algo va mal y lo correcto es no
     animar. */
  function retratoEbora() {
    var cab = document.querySelector('.cs-ebora__cab');
    if (!cab) return;
    if (retratoJugado) return;
    retratoJugado = true;

    if (performance.now() > 6000 || window.scrollY > 40) {
      return apunte('ebora-entrada-fuera-de-tiempo', {
        ms: Math.round(performance.now()),
        scroll: Math.round(window.scrollY)
      });
    }

    var ante = cab.querySelector('.cs-eyebrow');
    var nombre = cab.querySelector('.cs-ebora__nombre');
    var filas = cab.querySelectorAll('.cs-ebora__fila');
    var entrada = cab.querySelector('.cs-ebora__entrada');
    var firma = cab.querySelector('.cs-ebora__firma-t');
    var subfirma = cab.querySelector('.cs-ebora__firma-x');
    var retrato = cab.querySelector('.cs-ebora__retrato');

    var tl = gsap.timeline({ defaults: { ease: 'power3.out' } });
    entradaEbora = tl;

    if (ante) tl.from(ante, { opacity: 0, x: -14, duration: 0.7 }, 0);

    /* EL NOMBRE SE PINTA. Una pasada de izquierda a derecha, como el brochazo
       que descubre la tela. `clip-path` y no una máscara con más HTML: la
       caja del titular ya está medida al milímetro (line-height 1,3, que es
       la métrica de Instrument Serif) y meterle un envoltorio la movería.

       Los valores de arriba y abajo van en NEGATIVO — la franja recorta más
       alta que la letra — para que ni la tilde ni el rabo de la «b» se
       rocen. Y al acabar se retira el recorte entero: un `clip-path` que se
       queda puesto crea contexto de apilamiento para siempre, y ya no hace
       ninguna falta. */
    if (nombre) {
      tl.fromTo(
        nombre,
        { clipPath: 'inset(-12% 100% -12% 0%)' },
        {
          clipPath: 'inset(-12% 0% -12% 0%)',
          duration: 1.15,
          ease: 'power2.inOut',
          onComplete: function () { gsap.set(nombre, { clearProps: 'clipPath' }); }
        },
        0.12
      );
    }

    /* La cartela se coloca fila a fila, entrando desde la izquierda: es una
       ficha que alguien va rellenando, no un bloque que aparece de golpe. */
    if (filas.length) {
      tl.from(filas, { opacity: 0, x: -18, duration: 0.62, stagger: 0.07 }, 0.6);
    }

    if (entrada) tl.from(entrada, { opacity: 0, y: 16, duration: 0.8 }, 0.95);

    /* LA FIRMA SE FIRMA. Más lenta que todo lo demás y con una curva suave
       por los dos lados: una mano que firma no arranca de golpe ni frena en
       seco. Va la última de la banda a propósito. */
    if (firma) {
      tl.fromTo(
        firma,
        { clipPath: 'inset(-18% 100% -26% 0%)' },
        {
          clipPath: 'inset(-18% 0% -26% 0%)',
          duration: 1.6,
          ease: 'power1.inOut',
          onComplete: function () { gsap.set(firma, { clearProps: 'clipPath' }); }
        },
        1.2
      );
    }
    if (subfirma) tl.from(subfirma, { opacity: 0, duration: 0.6 }, 2.35);

    /* El retrato, si algún día hay foto: entra con el nombre y apenas se
       mueve. La foto de una persona no debe hacer acrobacias. */
    if (retrato) tl.from(retrato, { opacity: 0, scale: 1.04, duration: 1.2 }, 0.2);

    apunte('ebora-retrato', filas.length);
  }

  /* La línea de tiempo se DIBUJA al bajar: el raíl crece desde arriba, el
     punto salta cuando el raíl llega y el texto se enciende al lado.
     Un disparador por hito, y no uno para toda la trayectoria, para que el
     fallo de uno no se lleve por delante a los otros tres. */
  function trayectoEbora() {
    var hitos = document.querySelectorAll('.cs-hito');
    if (!hitos.length) return;

    Array.prototype.forEach.call(hitos, function (hito) {
      var rail = hito.querySelector('.cs-hito__rail');
      var punto = hito.querySelector('.cs-hito__punto');
      var marca = hito.querySelector('.cs-hito__marca');
      var titulo = hito.querySelector('.cs-hito__t');
      var texto = hito.querySelector('.cs-hito__x');

      var tl = gsap.timeline({
        scrollTrigger: {
          trigger: hito,
          /* EL RECORRIDO SE MIDE CONTRA LA PANTALLA, NO CONTRA EL HITO.
             De 'top 88%' a 'top 38%' son siempre MEDIA PANTALLA de scroll,
             mida lo que mida el texto. Dos problemas de una vez:

             · No depende del alto del hito, que era lo que hacía que el
               último de la lista pudiera no terminar nunca si debajo no
               quedaba página que lo empujara.
             · Y sobre todo: es el DOBLE de largo que antes. El recorrido
               anterior salía a 214 px medidos en la página, y una muesca de
               rueda mueve unos 100 — o sea que el hito entero se encendía en
               dos muescas y el dibujo de la línea no se veía nunca. Con media
               pantalla (430 px) da tiempo a verlo. */
          start: 'top 88%',
          end: 'top 38%',

          /* `true` Y NO UN NÚMERO. Un `scrub` con número es un suavizado que
             se SUMA al de Lenis, que ya glisa 1,15 s por muesca. Los dos
             juntos daban hasta segundo y medio entre mover la rueda y ver el
             texto encenderse: bajabas, te pasabas el hito con el texto aún
             apagado, y parecía que no funcionaba. Lo que Gabriel describió
             como «hay que bajar hasta abajo y luego subir».
             La suavidad la pone Lenis. Aquí no hace ninguna falta. */
          scrub: true,

          /* las fuentes y el lienzo 3D cambian el alto de la página después;
             sin esto el recorrido se queda con las medidas de antes */
          invalidateOnRefresh: true
        }
      });

      /* Con `scrub` las duraciones son PESOS, no segundos: se reparten por el
         recorrido del hito. El texto termina de encenderse en el primer 40%,
         o sea mucho antes de que a nadie le dé tiempo a querer leerlo. */
      if (punto) tl.fromTo(punto, { scale: 0 }, { scale: 1, ease: 'back.out(2.2)', duration: 0.18 }, 0);
      if (marca) tl.fromTo(marca, { opacity: 0, x: 12 }, { opacity: 1, x: 0, duration: 0.2 }, 0);
      if (titulo) tl.fromTo(titulo, { opacity: 0, y: 14 }, { opacity: 1, y: 0, duration: 0.25 }, 0.05);
      if (texto) tl.fromTo(texto, { opacity: 0, y: 14 }, { opacity: 1, y: 0, duration: 0.3 }, 0.12);
      if (rail) tl.fromTo(rail, { scaleY: 0 }, { scaleY: 1, ease: 'none', duration: 1 }, 0);
    });

    apunte('ebora-trayecto', hitos.length);
  }

  /* La coda se enciende PALABRA A PALABRA según se baja, como si se fuera
     leyendo. Nunca llega a estar apagada del todo: el suelo es 0,35, así que
     la frase se lee entera desde el primer momento y lo que hace el scroll es
     subirla a negro. Ésa es la diferencia entre un efecto y un texto que
     desaparece, y esa diferencia ya nos costó el párrafo del hero.
     Para darle o quitarle fuerza al efecto, ese 0,35 es el número. */
  function codaEbora() {
    var coda = document.querySelector('.cs-coda__t');
    if (!coda || !window.csLib) return;

    var intento = ++codaIntento;
    window.csLib
      .pide('splittext')
      .then(function () {
        if (intento !== codaIntento || codaPartida || !document.documentElement.classList.contains('cs-cine')) return;
        if (!window.SplitText) return;
        var fuentes = document.fonts && document.fonts.ready ? document.fonts.ready : Promise.resolve();
        return fuentes.then(function () {
          if (intento !== codaIntento || codaPartida || !document.documentElement.classList.contains('cs-cine')) return;

          var corte = new window.SplitText(coda, {
            type: 'words',
            wordsClass: 'cs-coda__p',
            aria: 'auto'
          });
          codaPartida = corte;
          codaAnimacion = gsap.fromTo(
            corte.words,
            { opacity: 0.35 },
            {
              opacity: 1,
              ease: 'none',
              stagger: 0.4,
              scrollTrigger: {
                trigger: coda,
                start: 'top 85%',
                end: 'top 25%',
                scrub: true,
                invalidateOnRefresh: true
              }
            }
          );
          apunte('ebora-coda', corte.words.length);
        });
      })
      .catch(function (e) {
        apunte('ebora-sin-splittext', String((e && e.message) || e));
      });
  }

  function derechosEbora() {
    var bloques = document.querySelectorAll('.cs-derechos > *');
    if (!bloques.length) return;

    gsap.fromTo(
      bloques,
      { opacity: 0, y: 18 },
      {
        opacity: 1,
        y: 0,
        ease: 'none',
        stagger: 0.25,
        scrollTrigger: {
          trigger: '.cs-derechos',
          start: 'top 94%',
          end: 'top 64%',
          scrub: true,
          invalidateOnRefresh: true
        }
      }
    );
  }

  /* LA RED, y por qué es tan pequeña.

     La primera versión de esto barría media página a los 6 s encendiendo
     todo lo que estuviera en pantalla y apagado. Medido, hacía más daño que
     bien: a los 6 s casi siempre hay algo a medio entrar por abajo —es lo
     normal— y forzarlo a 1 provocaba un destello, porque al siguiente tic de
     scroll el `scrub` lo devolvía a su valor. Una red que pelea con lo que
     protege no es una red.

     Lo que de verdad puede quedarse colgado es UNA sola cosa: la entrada del
     retrato, que es la única pieza que va por tiempo y no por scroll. Todo
     lo demás lleva `scrub`, o sea que su estado es una función de dónde
     estás: si está pasado, está encendido, y no hay disparo que pueda
     fallar. Por construcción no necesita red.

     Así que la red es esta línea: si a los 6 s la entrada se quedó a medias,
     se la lleva a su final. */
  function rescateEbora() {
    setTimeout(function () {
      if (entradaEbora && entradaEbora.progress() < 1) {
        entradaEbora.progress(1);
        apunte('ebora-rescate-entrada');
      }
    }, 6000);
  }

  /* Lo que hay que deshacer cuando matchMedia desarma (ventana estrecha).
     GSAP revierte solo sus transforms; lo que NO sabe deshacer es el corte
     de SplitText, que reescribe el HTML del párrafo. Se deshace aquí y el
     texto vuelve a ser un párrafo de una pieza. */
  function eboraDesarmar() {
    codaIntento++;
    if (codaAnimacion) {
      if (codaAnimacion.scrollTrigger) codaAnimacion.scrollTrigger.kill();
      codaAnimacion.kill();
      codaAnimacion = null;
    }
    if (codaPartida) {
      codaPartida.revert();
      codaPartida = null;
    }
    entradaEbora = null;
  }

  function ebora() {
    if (!document.querySelector('.cs-ebora')) return;
    retratoEbora();
    trayectoEbora();
    codaEbora();
    derechosEbora();
    rescateEbora();
  }

  /* ---------- 9. El panel de reseñas ---------- */

  var paredResenas = null; /* la instancia de Three.js, para poder soltarla */

  /* La pared de galería en WebGL, detrás del panel de la portada.

     SE PIDE TARDE Y SOLO SI HACE FALTA. Three.js son 163 KB comprimidos; no
     los paga nadie que no llegue a ver el panel en una pantalla grande. Por
     eso la importación es dinámica y va dentro de un IntersectionObserver con
     margen: empieza a bajar cuando el panel está a una pantalla de distancia,
     y si el visitante nunca baja hasta ahí, no se descarga nunca.

     Y si algo falla —no hay WebGL, el módulo no llega, el navegador no sabe
     de `import()` dinámico— no pasa absolutamente nada: el lienzo se queda
     vacío y transparente detrás de un panel que ya se veía entero. */
  function paredDeResenas(seccion) {
    var lienzo = seccion.querySelector('[data-cs-resenas-lienzo]');
    var urlThree = seccion.getAttribute('data-three');
    /* Las dos rutas vienen de Liquid y no se escriben a mano: Shopify sirve
       los assets desde su CDN con un sello de version en la URL, asi que una
       ruta relativa no resolveria nunca. Es lo mismo que hace cs-libreria.js. */
    var urlPared = seccion.getAttribute('data-pared');
    if (!lienzo || !urlThree || !urlPared) return;

    var pedida = false;
    var ojo = new IntersectionObserver(
      function (entradas) {
        if (!entradas[0].isIntersecting || pedida) return;
        pedida = true;
        ojo.disconnect();

        /* SE CUELGA UNA ETIQUETA, NO SE HACE import().
           Shopify minifica el JS del tema al servirlo, y su minificador
           convierte el `import()` dinámico de un guion clásico en
           `require(...)`, que en el navegador no existe: medido en la tienda,
           este fichero llegaba con 15 KB de los 45 que tiene y la consola
           decía «require is not defined». Una etiqueta <script type="module">
           no la toca nadie, y el módulo del otro lado sí conserva su import.
           El módulo se monta solo y avisa por el evento. */
        window.addEventListener('cs-pared-lista', function () {
          paredResenas = window.csParedResenas;
          if (!paredResenas) return;
          apunte('resenas-pared-3d');
          enganchaPared(seccion, paredResenas);
        }, { once: true });

        var etiqueta = document.createElement('script');
        etiqueta.type = 'module';
        etiqueta.src = urlPared;
        etiqueta.onerror = function () { apunte('resenas-pared-falla', 'no cargó el módulo'); };
        document.head.appendChild(etiqueta);
      },
      { rootMargin: '100% 0px' }
    );
    ojo.observe(seccion);
  }

  /* El scroll mueve el foco de la pared, y el ratón lo inclina.
     El progreso va con `scrub` puro: la luz es una función de dónde estás. */
  function enganchaPared(seccion, pared) {
    ScrollTrigger.create({
      trigger: seccion,
      start: 'top bottom',
      end: 'bottom top',
      onUpdate: function (self) { pared.progreso(self.progress); },
      invalidateOnRefresh: true
    });

    /* El ratón NO va con quickTo ni con una variable CSS: se le pasa el valor
       al shader y lo suaviza él solo dentro de la GPU. Es justo la lección de
       la sala — animar una variable CSS dentro de un degradado repinta la
       capa entera sesenta veces por segundo, y eso fue lo que dio tirones. */
    seccion.addEventListener('pointermove', function (e) {
      var r = seccion.getBoundingClientRect();
      pared.raton(
        ((e.clientX - r.left) / r.width) * 2 - 1,
        ((e.clientY - r.top) / r.height) * 2 - 1
      );
    }, { passive: true });

    seccion.addEventListener('pointerleave', function () { pared.raton(0, 0); }, { passive: true });
  }

  /* El 4,9 cuenta hasta su cifra.

     `immediateRender: false` es la pieza que lo hace seguro: sin eso, GSAP
     escribe el estado de partida (el 0) EN CUANTO se crea el tween, o sea
     mucho antes de que el panel se vea — y si el disparo no llegara nunca, el
     visitante se quedaría mirando un 0,0 donde pone 4,9. Con esto, el número
     del HTML no se toca hasta que la animación arranca de verdad. */
  function cuentaLaNota(seccion) {
    var el = seccion.querySelector('[data-cs-cuenta]');
    if (!el) return;
    var destino = parseFloat((el.getAttribute('data-cs-cuenta') || '').replace(',', '.'));
    if (!(destino > 0)) return;

    var caja = { v: 0 };
    gsap.to(caja, {
      v: destino,
      duration: 1.4,
      ease: 'power2.out',
      immediateRender: false,
      onUpdate: function () { el.textContent = caja.v.toFixed(1).replace('.', ','); },
      scrollTrigger: { trigger: el, start: 'top 88%', once: true }
    });
  }

  function resenas() {
    var secciones = document.querySelectorAll('.cs-resenas');
    if (!secciones.length) return;

    Array.prototype.forEach.call(secciones, function (seccion) {
      /* Las tarjetas entran escalonadas. Con `scrub` acotado a media pantalla,
         como los hitos de la página del pintor: no puede quedarse a medias. */
      var tarjetas = seccion.querySelectorAll('.cs-resena');
      if (tarjetas.length) {
        gsap.fromTo(
          tarjetas,
          { opacity: 0, y: 26 },
          {
            opacity: 1,
            y: 0,
            ease: 'none',
            stagger: 0.12,
            scrollTrigger: {
              trigger: seccion.querySelector('[data-cs-resenas]') || seccion,
              start: 'top 92%',
              end: 'top 42%',
              scrub: true,
              invalidateOnRefresh: true
            }
          }
        );
      }

      /* El marcador —el 4,9 y las estrellas— entra antes que las tarjetas: es
         el titular de la banda y tiene que estar puesto cuando se lea. */
      var marcador = seccion.querySelector('.cs-resenas__marcador');
      if (marcador) {
        gsap.fromTo(
          marcador,
          { opacity: 0, y: 18 },
          {
            opacity: 1,
            y: 0,
            ease: 'none',
            scrollTrigger: {
              trigger: marcador,
              start: 'top 95%',
              end: 'top 62%',
              scrub: true,
              invalidateOnRefresh: true
            }
          }
        );
      }

      cuentaLaNota(seccion);

      if (seccion.hasAttribute('data-cs-resenas-3d')) paredDeResenas(seccion);
    });

    apunte('resenas', secciones.length);
  }

  /* ---------- carril rápido: SOLO la entrada del retrato ----------

     EL PROBLEMA. `cuandoQuepa` espera al evento `load` —a que termine hasta
     el último iframe de la página— y luego a un hueco de inactividad. Medido
     en la tienda: GSAP no estaba listo hasta 1,1 s con la caché caliente, y
     bastante más en una primera visita. Como la página se ve entera desde el
     principio, lo que pasaba es que el nombre estaba ahí quieto y al cabo de
     un segundo se repintaba solo. Gabriel: «tarda un poco en aparecer la
     animación». Tenía razón.

     POR QUÉ SE PUEDE ADELANTAR ESTA Y NO EL RESTO. La espera a `load` está
     para que las imágenes hayan dado su altura antes de que ScrollTrigger
     mida dónde empieza cada sección; sin eso, mide sobre una página
     comprimida. Pero **la entrada del retrato no mide nada**: es una línea
     de tiempo sobre elementos que ya están en su sitio, sin un solo
     disparador de scroll. O sea que la razón de esperar no le aplica.

     Así que la entrada arranca en cuanto se lee este fichero, y todo lo
     demás —los hitos, la coda, los derechos, y las coreografías de las otras
     páginas— sigue esperando a `load` exactamente igual que antes. */
  function carrilRapidoEbora() {
    if (!document.querySelector('.cs-ebora__cab')) return;
    /* las mismas condiciones que el propio retrato: si no se cumplen, ni se
       molesta en pedir 114 KB de GSAP */
    if (window.scrollY > 40) return;
    if (window.innerWidth < 750) return;
    var reducido = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reducido && !forzado) return;

    apunte('ebora-carril-rapido');
    conGsap()
      .then(function () {
        apunte('ebora-gsap-pronto', Math.round(performance.now()));
        retratoEbora();
      })
      .catch(function (e) {
        /* si falla, el arranque normal lo intentará otra vez más tarde */
        apunte('ebora-carril-rapido-falla', String((e && e.message) || e));
      });
  }
  carrilRapidoEbora();

  /* ---------- arranque ---------- */

  apunte('esperando-hueco', { estado: document.readyState });
  /* Antes de pedir 114 KB de GSAP, dos preguntas. Las dos se hacen AQUÍ y no
     al leer el guion, porque a estas alturas la página ya está cargada y las
     medidas son de fiar — la lección de la primera versión.

     1. ¿Hay algo que mover en esta página? En un carrito o en una página
        legal no hay ni hero, ni rejilla, ni banda: no se descarga nada.
     2. ¿Estamos en un teléfono? El umbral es deliberadamente bajo (500) y no
        el mismo 750 de la coreografía: entre 500 y 750 GSAP se descarga y
        queda listo por si el visitante gira el aparato o agranda la ventana,
        que es justo lo que matchMedia sabe atender. Por debajo de 500 no hay
        giro que valga: es un móvil y se queda sin capa de scroll. */
  function hayObjetivos() {
    return !!document.querySelector(
      '.custom-hero, .cs-obra, .cs-tema, .cs-sala-cab, .cs-head, .cs-ebora, .cs-resenas, [data-cs-pasillo]'
    );
  }

  cuandoQuepa(function () {
    apunte('hueco');
    if (!hayObjetivos()) return apunte('nada-que-mover');
    if (window.innerWidth < 500) return apunte('telefono', window.innerWidth);
    conGsap()
      .then(function () {
        apunte('gsap-listo', gsap.version);
        gsap.registerPlugin(ScrollTrigger);

        /* POR QUÉ matchMedia DE GSAP Y NO UN `if` CON EL ANCHO.
           La primera versión de esto medía la ventana UNA VEZ, al leer el
           guion, y se guardaba un booleano. Nunca llegó a armarse: con
           `defer` el guion corre con la página aún en 'interactive', y ahí
           la ventana todavía no tiene su tamaño definitivo — medía estrecho
           y se iba por la rama del móvil. Le pasaría igual a cualquiera que
           abra la tienda con la ventana pequeña y luego la agrande, o que
           gire el teléfono.

           gsap.matchMedia() no mide: SUSCRIBE. Monta la coreografía cuando
           se cumple la condición, la desmonta cuando deja de cumplirse —y al
           desmontarla revierte los transforms que había puesto, que es justo
           lo que hay que hacer para no dejar una obra desplazada a medias. */
        var mm = gsap.matchMedia();
        var condicion = forzado
          ? '(min-width: 750px)'
          : '(min-width: 750px) and (prefers-reduced-motion: no-preference)';

        mm.add(condicion, function () {
          document.documentElement.classList.add('cs-cine');
          /* El scroll suave va el primero: si llega tarde, ScrollTrigger ya
             habría medido con el scroll de siempre. No se espera a que
             termine — es una mejora, no un requisito. */
          /* hero() YA NO SE LLAMA (19 sep 2026). El parallax de scroll del
             hero se retira entero; el porque, en la cabecera de la funcion. */
          obras();
          mosaico();
          bandaColeccion();
          pasillo();
          /* El scroll suave, DESPUÉS del pasillo: necesita saber si ha
             quedado alguna sección anclada para apartarse. */
          scrollSuave();
          titulares();
          cabeceras();
          ebora();
          resenas();
          apunte('armado', ScrollTrigger.getAll().length);

          /* Las fuentes y el lienzo 3D llegan tarde y mueven la página; sin
             esto, ScrollTrigger se queda con las medidas de antes y las
             animaciones disparan donde ya no toca. */
          ScrollTrigger.refresh();
          if (document.fonts && document.fonts.ready) {
            document.fonts.ready.then(function () { ScrollTrigger.refresh(); });
          }

          /* Lo que devuelve matchMedia es la limpieza: se llama sola al
             salir de la condición. */
          return function () {
            document.documentElement.classList.remove('cs-cine');
            eboraDesarmar();
            if (paredResenas) { paredResenas.fin(); paredResenas = null; }
            apunte('desarmado');
          };
        });
      })
      .catch(function (e) {
        apunte('fallo', String((e && e.message) || e));
        /* Sin GSAP no pasa nada: la página se ve entera, solo que quieta.
           Las entradas de cs-vivo.js siguen funcionando por su cuenta. */
      });
  });
})();
